import ICAMProtected from './ICAMProtected';

export default ICAMProtected;
